import { render, staticRenderFns } from "./RatingsToClientTab.vue?vue&type=template&id=33c8d02a&scoped=true"
import script from "./RatingsToClientTab.vue?vue&type=script&lang=js"
export * from "./RatingsToClientTab.vue?vue&type=script&lang=js"
import style0 from "./RatingsToClientTab.vue?vue&type=style&index=0&id=33c8d02a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c8d02a",
  null
  
)

export default component.exports